const Rails = require('@rails/ujs');
import * as activestorage from 'activestorage';

export class RailsInitializer {
	static init() {
		if (!window._rails_loaded) {
			Rails.start();

			activestorage.start();
		}
	}
}
